import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";
import MapTool from "@mapmycustomers/shared/enum/map/MapTool";

import { NoData } from "@app/component/RecordList";
import useMapView from "@app/component/view/utils/useMapView";
import LassoToolMode from "@app/scene/map/enums/LassoToolMode";
import {
  getLassoMode,
  getMapViewState,
  getMapViewTool,
  getVisibleLassoEntityTypes,
} from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";
import useClearMapFilters from "@app/util/hook/useClearMapFilters";

interface Props {
  noEntityTypesSelected: boolean;
}

const MapModeNoData: React.FC<Props> = ({ noEntityTypesSelected }) => {
  const {
    updateViewStateAndFetch,
    viewState: { tool },
  } = useMapView();
  const intl = useIntl();

  const handleResetAllFilters = useClearMapFilters();

  const handleClear = useCallback(() => {
    if (noEntityTypesSelected) {
      updateViewStateAndFetch({
        request: { visibleEntities: [EntityType.COMPANY, EntityType.PERSON, EntityType.DEAL] },
      });
    } else {
      handleResetAllFilters();
    }
  }, [handleResetAllFilters, noEntityTypesSelected, updateViewStateAndFetch]);

  const isLassoMode = tool === MapTool.LASSO;

  return (
    <NoData
      actionTitle={
        noEntityTypesSelected
          ? intl.formatMessage({
              id: "map.recordsList.noEntityTypesSelected.action",
              defaultMessage: "Show All Pins",
              description: "No entity types action",
            })
          : undefined
      }
      onAction={handleClear}
      showAction={!isLassoMode}
      showText={!isLassoMode}
      text={
        noEntityTypesSelected
          ? intl.formatMessage({
              id: "map.recordsList.noEntityTypesSelected",
              defaultMessage:
                "You have turned off all pins. Please re-enable Companies, People, or Deals to see results.",
              description: "No entity types title",
            })
          : undefined
      }
      title={
        isLassoMode
          ? intl.formatMessage({
              id: "map.recordsList.lasso.noSelection",
              defaultMessage: "No selected pins",
              description: "No selected pins title",
            })
          : undefined
      }
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  noEntityTypesSelected:
    (getMapViewTool(state) === MapTool.LASSO && getLassoMode(state) === LassoToolMode.ADD_GROUP_PINS
      ? getVisibleLassoEntityTypes(state)
      : getMapViewState(state).visibleEntities
    ).length === 0,
});

export default connect(mapStateToProps)(MapModeNoData);
